import { render, staticRenderFns } from "./DataAssetSoft.vue?vue&type=template&id=6ca6c2b6&scoped=true"
import script from "./DataAssetSoft.vue?vue&type=script&lang=js"
export * from "./DataAssetSoft.vue?vue&type=script&lang=js"
import style0 from "./DataAssetSoft.vue?vue&type=style&index=0&id=6ca6c2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6c2b6",
  null
  
)

export default component.exports